type CTAProps = {
  onApply: () => void;
  isManuallyClosed: boolean;
};

export default function CTA({ onApply, isManuallyClosed }: CTAProps) {
  return (
    <section className="py-10 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-10">
        <div className="relative rounded-2xl bg-primary-500 text-background-50 p-5 md:p-14 overflow-hidden">
          <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-primary-400/40 blur-2xl"></div>
          <div className="absolute -left-10 -bottom-10 w-52 h-52 rounded-full bg-accent-400/30 blur-2xl"></div>

          <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="min-w-0">
              <span className="inline-block text-[10px] md:text-sm font-semibold tracking-widest uppercase opacity-90">
                Ready to start?
              </span>
              <h2 className="mt-3 font-heading text-xl sm:text-3xl md:text-4xl font-bold leading-snug break-all">
                8주 뒤,  일본 여행에서
                <br className="block" />
                직접 말하는 자신을
                <br className="block" />
                만나보세요.
              </h2>
              <p className="mt-3 text-background-100/90 text-xs md:text-base break-all">
                최대 5명 소수정예로 진행되기 때문에 마감이 빠를 수 있어요.
              </p>
            </div>

            <button
              onClick={onApply}
              disabled={isManuallyClosed}
              className={`inline-flex items-center justify-center gap-2 px-6 py-3 sm:px-8 sm:py-4 rounded-md text-sm sm:text-base font-bold transition-colors whitespace-nowrap ${
                isManuallyClosed
                  ? "bg-background-300 text-foreground-400 cursor-not-allowed"
                  : "bg-background-50 text-primary-600 hover:bg-background-100 cursor-pointer"
              }`}
            >
              {isManuallyClosed ? "신청 마감" : "수강 신청하기"}
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}